import { IApplicationState } from '../../types/redux';
import { selectNewbuildingsCompareBlocks } from './selectNewbuildingsCompareBlocks';

/** Сколько ЖК в таблице сравнения: число ячеек строки `newbuildingSummary` (по одной на ЖК). */
export function selectNewbuildingsCount(state: IApplicationState): number {
  const summaryRow = selectNewbuildingsCompareBlocks(state)
    .flatMap(block => block.rows)
    .find(row => row.type === 'newbuildingSummary');

  return summaryRow?.cells.length ?? 0;
}
